import { AfterViewInit, Component, ElementRef, OnDestroy, output, signal, viewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import trimCanvas from 'trim-canvas';

@Component({
  selector: 'lfe-signature-canvas',
  imports: [],
  standalone: true,
  templateUrl: './signature-canvas.component.html',
  styleUrl: './signature-canvas.component.css'
})
export class SignatureCanvasComponent implements AfterViewInit, OnDestroy {
  private beginStrokeHandler?: () => void;
  readonly signatureCanvas = viewChild.required<ElementRef<HTMLCanvasElement>>('signatureCanvas');

  readonly hasDrawnChange = output<boolean>();

  signaturePad = signal<SignaturePad | null>(null);

  ngAfterViewInit(): void {
    const canvasEl = this.signatureCanvas().nativeElement;
    const signaturePad = new SignaturePad(canvasEl, {
      throttle: 16
    });
    this.signaturePad.set(signaturePad);

    this.beginStrokeHandler = () => {
      this.hasDrawnChange.emit(true);
    };
    signaturePad.addEventListener('beginStroke', this.beginStrokeHandler);
  }

  ngOnDestroy(): void {
    const pad = this.signaturePad();
    if (pad && this.beginStrokeHandler) {
      pad.removeEventListener('beginStroke', this.beginStrokeHandler);
      pad.off();
    }
  }

  getTrimmedCanvas = (): HTMLCanvasElement => {
    const copy = document.createElement('canvas');
    const canvasEl = this.signatureCanvas().nativeElement;
    copy.width = canvasEl.width;
    copy.height = canvasEl.height;
    copy.getContext('2d', { willReadFrequently: true })?.drawImage(canvasEl, 0, 0);
    return trimCanvas(copy);
  };

  getDataURL(): string {
    return this.getTrimmedCanvas().toDataURL() || '';
  }

  getBase64(): string {
    const dataURL = this.getDataURL();
    return dataURL.replace('data:image/png;base64,', '');
  }
}
